<template>
    <div class="tool-tip">
        {{ icon }}
        <div class="tool-tip-text" v-html="infoText">
        </div>
    </div>
</template>

<script>
export default {
    name: 'Tooltip',
    props: {
        icon: {
            type: String,
            required: true,
        },
        infoText: {
            required: false,
        },
    },
}
</script>

<style lang="scss" scooped>
.tool-tip {
    background-color: #d4d4d4;
    padding: 3px 10px;
    border-radius: 5px;
    font-weight: bold;
    color: #606060;
    transition: .15s all linear;
    position: relative;

    .tool-tip-text {
        visibility: hidden;
        opacity: 0%;
        background-color: black;
        color: #fff;
        text-align: center;
        padding: 5px 0;
        border-radius: 6px;
        font-weight: normal;
        width: 300px;
        height: auto;
        font-size: 13px;
        left: 50%;
        bottom: 50%;
        transform: translate(-50%, -50%);
        position: absolute;
        z-index: 1;

        &::after {
            content: " ";
            position: absolute;
            top: 100%;
            left: 50%;
            margin-left: -5px;
            border-width: 5px;
            border-style: solid;
            border-color: black transparent transparent transparent;
        }
    }

    &:hover {
        background-color: #acacac;
        color: #d8d8d8;

        .tool-tip-text {
            visibility: visible;
            opacity: 1;
        }
    }
}
</style>